import React from 'react';
import css from './HuePointer.module.scss';
import classnames from 'classnames';

const HuePointer = ({ color }) => {
    return (
        <div className={classnames(css.formColorPickerHue)}>
            <div style={{ backgroundColor: color }} className={classnames(css.formColorPickerItem)}></div>
        </div>
    );
};
export default HuePointer;
